import { SponsorTier } from '../types'

// Import sponsor logos
import AgiosLogo from '../../../assets/sponsorLogos/Agios_Logo.png'
import BluebirdLogo from '../../../assets/sponsorLogos/Bluebird_Logo.png'
import BristolMeyersLogo from '../../../assets/sponsorLogos/BristolMeyersSquibb_Logo.svg'
import ChiesiLogo from '../../../assets/sponsorLogos/Chiesi_Logo.png'
import FulcrumLogo from '../../../assets/sponsorLogos/Fulcrum_Logo.png'
import MedunikLogo from '../../../assets/sponsorLogos/Medunik_Logo.jpg'
import NovoNordiskLogo from '../../../assets/sponsorLogos/NovoNordisk_Logo.jpg'
import VertexLogo from '../../../assets/sponsorLogos/Vertex_Logo.png'
import SanofiLogo from '../../../assets/sponsorLogos/Sanofi_Color_Logo.png'
import TerumoLogo from '../../../assets/sponsorLogos/Terumo_Logo.png'
import GamidaCellLogo from '../../../assets/sponsorLogos/GamidaCell_Logo.jpg'
import PfizerLogo from '../../../assets/sponsorLogos/Pfizer_Logo.png'
import QuiltHealthLogo from '../../../assets/sponsorLogos/QuiltHealthColor_Logo.png'
import BeamLogo from '../../../assets/sponsorLogos/Beam_Logo.jpg'

export const sponsorData: SponsorTier[] = [
  {
    name: 'Diamond',
    sponsors: [
      { name: 'Sanofi', logo: SanofiLogo, website: 'https://www.sanofi.com' }
    ]
  },
  {
    name: 'Platinum',
    sponsors: [
      {
        name: 'NovoNordisk',
        logo: NovoNordiskLogo,
        website: 'https://www.novonordisk.com'
      },
      { name: 'Agios', logo: AgiosLogo, website: 'https://www.agios.com' },
      { name: 'Chiesi', logo: ChiesiLogo, website: 'https://www.chiesi.com' },
      {
        name: 'Blue Bird Bio',
        logo: BluebirdLogo,
        website: 'https://www.bluebirdbio.com'
      },
      { name: 'Vertex', logo: VertexLogo, website: 'https://www.vrtx.com' },
      {
        name: 'Quilt Health',
        logo: QuiltHealthLogo,
        website: 'https://www.quilthealth.com'
      }
    ]
  },
  {
    name: 'Gold',
    sponsors: [
      { name: 'Terumo', logo: TerumoLogo, website: 'https://www.terumo.com' },
      {
        name: 'Fulcrum Therapeutics',
        logo: FulcrumLogo,
        website: 'https://www.fulcrumtx.com'
      },
      {
        name: 'Medunik',
        logo: MedunikLogo,
        website: 'https://www.medunik.com'
      },
      {
        name: 'Gamida Cell',
        logo: GamidaCellLogo,
        website: 'https://www.gamida-cell.com'
      },
      {
        name: 'Bristol Meyers Squibb',
        logo: BristolMeyersLogo,
        website: 'https://www.bms.com'
      },
      { name: 'Pfizer', logo: PfizerLogo, website: 'https://www.pfizer.com' },
      {
        name: 'BEAM Therapeutics',
        logo: BeamLogo,
        website: 'https://www.beamtx.com'
      }
    ]
  }
]
